<div class="header">
    <img class="img" src="../../../../assets/image/logo 3.svg" alt="">
    <div class="dropdown" (click)="toggleDropdown()">
        <img src="../../../../assets/image/grievance/user-icon 1.svg" alt="">
        {{userId}}
         <img src="../../../../assets/image/dropDownIcon.svg" alt="">
        <ul class="dropdown-content" *ngIf="isOpen">
            
            <li>Name: {{userName}}</li>
            <!-- <li>Department: CSE</li> -->
            <li>Status: Current</li>
        </ul>
    </div>
</div>